import * as React from 'react';
import Icon from 'components/Icon';
import VideoPlaceholder from 'components/VideoPlaceholder';
import { classNames } from 'utils/ui/css';

type TParticipantVideoProps = {
  audioMuted: boolean;
  videoMuted: boolean;
  children: React.ReactNode;
  // allow additional class names to define who's on video
  className?: string;
};

const ParticipantVideo: React.FC<TParticipantVideoProps> = ({
  audioMuted = false,
  videoMuted = false,
  children,
  className,
}) => {
  return (
    <div className={classNames('ex3d-participant-video', className)} part="participant-video">
      {audioMuted ? (
        <div className="ex3d-icon-wrapper--mic-off">
          <Icon className="ex3d-icon--mic-off" />
        </div>
      ) : null}
      {videoMuted ? <VideoPlaceholder /> : children}
    </div>
  );
};

export default ParticipantVideo;
